import React from 'react'
import { Container, Image } from 'semantic-ui-react'

import reminder from '../../assets/images/reminder.png'
import { tr } from '../../helpers/languages'

const Reminder = (props) => {
    return (
        <Container className='session-reminder'>
            <Image src={reminder}/>
            <span>{tr('REMINDER')}</span>
            {props.session.previous_reminder}
        </Container>
    )
}

export default Reminder



// WEBPACK FOOTER //
// ./src/components/participant-session/reminder.js